import Model from '../models/model';
import consts from '../consts';

const model = new Model({
	name: 'Client',
	api: 'Client',
	idProperty: 'HospitalId',
	defaultSort: 'Name',
	disableAdd: true,
	disableDelete: true,
	hideSubmit: true,
	showGridRefreshBtn: true,
	initialValues: {
		IsActive: true,
		DefaultLanguageId: consts.LanguageName.default
	},
	formTitleField: 'HospitalUniqueId',
	title: 'Client',
	combos: [{ type: 'DefaultLang', loaded: true }],
	columns: [
		{ header: 'UniqueId', field: 'HospitalId', hide: true, width: 120, readOnly: true },
		{ field: 'HospitalUniqueId', header: 'HospitalUniqueId', width: 180, readOnly: true, minLength: 1, maxLength: 16 },
		{ field: 'AccountNumber', header: 'AccountNumber', width: 180, readOnly: true },
		{ field: 'Name', header: 'ClientName', width: 180, readOnly: true },
		{
			field: 'DefaultLanguage',
			formField: 'DefaultLanguageId',
			header: 'DefaultLanguage',
			width: 180,
			lookup: 'DefaultLang',
			ignoreLookupOnGridFilter: true,
			readOnly: true
		},
		{ field: 'MachineKey', header: 'MachineKey', width: 180, readOnly: true },
		{
			field: 'CreatedOn',
			type: 'dateTime',
			filterType: 'date',
			width: 180,
			isLocal: true,
			isNotformfield: true,
			readOnly: true
		},
		{
			field: 'ModifiedOn',
			type: 'dateTime',
			filterType: 'date',
			width: 180,
			isLocal: true,
			isNotformfield: true,
			readOnly: true
		},
		{ field: 'Address', width: 180, readOnly: true },
		{ field: 'TimeZone', header: 'TimeZones', lookup: 'TimeZones', width: 150, excludeOnGrid: true, readOnly: true }
	]
});

export default model.createFormBase();
